import React from 'react';
import { useNavigate } from 'react-router-dom';



const CTA = ({ onGetStarted }) => {

    return (
        <section className="cyhno">
            {/* Bg */}
            <div className="cbnx3 cx5bd ctehq cakxp" aria-hidden="true" />
            <div className="cl9ye cc8xx cdcfy chlof" data-aos="fade-up">
                <div className="c55v2 cdioo">
                    <div className="crjhh c38qt c3jio cxwkc c5mm2">
                        {/* CTA content */}
                        <div className="c226t clpz0 cpct6 cfe0z c1ig3">
                            <p className="c29au c50dd c1dgw czmmv">What are you waiting for?</p>
                            <h2 className="c9gu4 caveb">Take your store online with <br />Craft My Store</h2>
                        </div>
                        {/* Buttons */}
                        <div className="ce0su">
                            <div className="c21hj ckig3 c0czj c896x cgkx4 cf5tr cw6hw c5mm2 c5llv cdcfy c8glp">
                                <div>
                                    <a
                                        className="cv52j c38qt cyuce c98p9 ckk70 co504 cn4p0 cjkjb ck31x cpointer"
                                        onClick={onGetStarted}
                                    >
                                        Get Started
                                        <span className="cddud cq3sh c514c ccbbk cgdcn cw78b ckf0b">
                                            <svg className="cf9f3" width={12} height={10} xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 6.002h7.586L6.293 8.295a1 1 0 1 0 1.414 1.414l4-4a1 1 0 0 0 0-1.416l-4-4a1 1 0 0 0-1.414 1.416l2.293 2.293H1a1 1 0 1 0 0 2Z">
                                                </path>
                                            </svg>
                                        </span>
                                    </a>
                                </div>
                                <div>
                                    <a className="ctsgt ctopb c2c8i cdqaz c4sti cpi22 cmjy8 c38qt cg0z9 c98p9 c4nhw co504 cyhno cn4p0 cjkjb" target="_blank" href="https://api.whatsapp.com/send?phone=7718837352&text=Hello, I am interested in your services, would love to discuss on that.">Chat
                                        on Whatsapp</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CTA;



